import { useEffect, useState } from 'react';
import { syndicationApi } from '../syndication-api';
import { serializeChannelSubscriptions } from '../syndication-api/utils';
import { SYNDICATION_GET_ERROR } from '../syndication-api/syndication-api';

export const getChannelSelectionMap = (subscriptions) => {
  const isSelected = false;
  return subscriptions.reduce((subscriptionMap, subscriptionItem) => {
    const { id, channelName } = subscriptionItem;
    subscriptionMap[id] = {
      id,
      channelName,
      isSelected,
    };
    return subscriptionMap;
  }, {});
};

export const useChannelSelection = () => {
  const [channels, setChannels] = useState([]);
  const [channelSelectionMap, setChannelSelectionMap] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  const getAllSubscriptions = async () => {
    try {
      const { subscriptions = {} } =
        await syndicationApi.getAllSyndicationSubscriptions();
      const normalizedChannels = serializeChannelSubscriptions(subscriptions);
      setChannelSelectionMap(getChannelSelectionMap(normalizedChannels));
      setChannels(normalizedChannels);
    } catch (e) {
      setErrorMessage(SYNDICATION_GET_ERROR);
    }
  };

  useEffect(() => {
    getAllSubscriptions();
  }, []);

  const getSelectedChannels = () =>
    Object.values(channelSelectionMap).filter((channel) => channel.isSelected);

  const updateChannelSelection = (channelId, isSelected) => {
    setChannelSelectionMap((prevState) => ({
      ...prevState,
      [channelId]: {
        ...prevState[channelId],
        isSelected,
      },
    }));
  };

  const updateAllChannelsSelections = (event) => {
    const isSelected = event.target.checked;
    const updatedSelections = Object.values(channelSelectionMap).reduce(
      (selectionMap, channel) => {
        selectionMap[channel.id] = {
          ...channel,
          isSelected,
        };
        return selectionMap;
      },
      {}
    );
    setChannelSelectionMap(updatedSelections);
  };

  const areAllChannelsSelected = Object.values(channelSelectionMap).every(
    ({ isSelected }) => isSelected
  );

  const areSomeChannelsSelected = Object.values(channelSelectionMap).some(
    ({ isSelected }) => isSelected
  );

  const isIndeterminate = !areAllChannelsSelected && areSomeChannelsSelected;
  const amountChannelsSelected = getSelectedChannels().length || 0;

  return {
    amountChannelsSelected,
    areAllChannelsSelected,
    errorMessage,
    channels,
    channelSelectionMap,
    isIndeterminate,
    updateChannelSelection,
    updateAllChannelsSelections,
  };
};
